export default __webpack_public_path__ + "static/media/22.2de30e79.jpg";